import { toast } from "@/components/common/Toast"
import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useCreateStepUpSession } from "@/services/api/billingService"
import { markUpgradeLinkOpened } from "@/utils/upgradeSession"
import { isStripeUrl } from "./ManagePlanButton"

/** Opens Stripe's page that moves the Starter subscription to Pro. */
export const StepUpButton: React.FC = () => {
  const { translate } = useTranslation()
  const stepUp = useCreateStepUpSession()

  const open = () =>
    stepUp.mutate(undefined, {
      onSuccess: ({ url }) => {
        if (isStripeUrl(url)) {
          markUpgradeLinkOpened({ stepUp: true })
          window.location.assign(url)
        } else {
          toast.error(translate("UPGRADE/STEP_UP_ERROR"))
        }
      },
      onError: () => toast.error(translate("UPGRADE/STEP_UP_ERROR")),
    })

  return (
    <Button disabled={stepUp.isPending} onClick={open}>
      {translate("UPGRADE/STEP_UP")}
    </Button>
  )
}
